export const API_URL = 'https://stagingapi.lightingreality.studio/api';
